import { SpeedInsights } from '@vercel/speed-insights/react'
import { useLocation } from 'react-router-dom'

export function DashboardSpeedInsights() {
  const { pathname } = useLocation()

  // Magic-login URLs contain bearer credentials until redemption strips them.
  // Start telemetry only after the flow navigates to an ordinary route.
  if (pathname.startsWith('/t/')) return null

  return <SpeedInsights beforeSend={event => {
    const url = new URL(event.url)
    if (url.pathname.startsWith('/t/')) return null
    url.search = ''
    url.hash = ''
    return { ...event, url: url.href }
  }} />
}
